/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintForLength extends models.ParameterConstraintBaseForString {
    constructor() {
        super();
        this.setDiscriminator("ParameterConstraintForLength");
    }

    getFixupPrototypeFunction() { return ParameterConstraintForLength.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintForLength>): ParameterConstraintForLength {
        let obj = Object.assign(new ParameterConstraintForLength(), model);
        ParameterConstraintForLength.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintForLength>): ParameterConstraintForLength {
        if (!model) return null;
        return ParameterConstraintForLength.newInstance(<ParameterConstraintForLength> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintForLength) {
        if (!obj) return;

        models.ParameterConstraintForLength.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintForLength): boolean {
        if (models.ParameterConstraintBaseForString.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintForLength.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.min_length === undefined) {
            this.min_length = 0;
        }
        if (this.max_length === undefined) {
            this.max_length = 0;
        }
    }

    /**
     * Minimum length of the parameter's constraint field
     */
    min_length: number;

    /**
     * Maximum length of the parameter's constraint field
     */
    max_length: number;

}
